// import PersonalHeader from '../../views/personal/PersonalHeader.vue';

import ability_routes from "./ability"; // 微能力教师路由
import {
    abilityOtherRoutes
} from "./ability"; // 微能力教师路由
import {
    noAbilityOtherRoutes
} from "./no_ability"; // 非微能力教师路由
// import {} from "./ability"; // 微能力教师路由
import no_ability_routes from "./no_ability"; // 非微能力教师路由

// console.log(ability_routes);
// console.log(abilityOtherRoutes);
// 个人中心头部
const tearch_routes = [
    [
        // 教师微能力测评列表
        {
            path: "/abilityEvaluaList",
            name: "AbilityEvaluaList",
            meta: {
                showName: 1,
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评列表'
                },
                ]
            },
            component: () =>
                import(
                    "../../views/personal/tearch/AbilityEvaluaList.vue"
                ),
        },
        // 蓝天项目对接-我的项目
        {
            path: '/lanTianProject',
            name: 'LanTianProject',
            meta: {
                breadCrumd: [
                    {
                        path: '/',
                        name: '我的培训项目'
                    },
                ]
            },
            component: () => import('../../views/personal/tearch/ability/lantianPages/xiangmu.vue'),
        },
        // 蓝天项目对接-我的课程
        {
            path: '/lanTianClass',
            name: 'LanTianClass',
            meta: {
                breadCrumd: [
                    {
                        path: '/',
                        name: '我的培训项目'
                    },
                ]
            },
            component: () => import('../../views/personal/tearch/ability/lantianPages/kecheng.vue'),
        },
        // 个人资料
        {
            path: "/userData",
            name: "UserData",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '个人资料'
                },]
            },
            component: () =>
                import(
                    "../../views/personal/tearch/userData/index.vue"
                ),
        },
        // 个人资料
        {
            path: "/setPassword",
            name: "SetPassword",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '个人资料'
                },]
            },
            component: () =>
                import(
                    "../../views/personal/tearch/setPassword.vue"
                ),
        },
        // 教师微能力测评
        {
            path: "/abilityevaluation",
            name: "AbilityEvaluation",
            meta: {
                showName: 1,
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityEvaluation" */
                    "../../views/personal/tearch/AbilityEvaluation.vue"
                ),
        },
        // 个人测评报告测评报告
        {
            path: "/personagetestnoticeschool",
            name: "AbilityEvaluation",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: '教师微能力测评报告(个人)'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "PersonageTestNotice" */
                    "../../views/personal/PersonageTestNotice.vue"
                ),
        },
        // 微能力考试
        {
            path: "/abilityexam",
            name: "AbilityEvaluation",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: '参与测评'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityExam" */
                    "../../views/personal/tearch/AbilityExam.vue"
                ),
        },
        // 教师证书详情
        {
            path: "/abilitycertificatedetail",
            name: "AbilityCertificate",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '证书'
                },
                {
                    path: '/',
                    name: '证书详情'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityCertificateDetail" */
                    "../../views/personal/tearch/ability/AbilityCertificateDetail.vue"
                ),
        },
        // 微能力教师我学习的
        {
            path: "/abilitymystudy",
            name: "AbilityMyStudy",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '我的课程'
                },
                {
                    path: '/',
                    name: '我学习的'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityMyStudy" */
                    "../../views/personal/tearch/ability/AbilityMyStudy.vue"
                ),
        },
        // 微能力教师我收藏的
        {
            path: "/abilitymycollection",
            name: "AbilityMyCollection",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '我的课程'
                },
                {
                    path: '/',
                    name: '我收藏的'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityMyStudy" */
                    "../../views/personal/tearch/ability/AbilityMyStudy.vue"
                ),
        },

    ],
    [
        // 立即购买
        {
            path: "/nowtopay",
            name: "NowToPay",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: '购买'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NowToPay" */
                    "../../views/personal/tearch/NowToPay.vue"
                ),
        },

    ],
];

// 获取本地信息
let webUserInfo = {};
if (localStorage.getItem("webUserInfo")) {
    webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
}
// 能力类型 0无 1微能力 2非微能力
if (webUserInfo.ability_type == 1) {
    // 添加微能力路由
    tearch_routes[0] = tearch_routes[0].concat(ability_routes);
    tearch_routes[1] = tearch_routes[1].concat(abilityOtherRoutes);
} else if (webUserInfo.ability_type == 2) {
    tearch_routes[0] = tearch_routes[0].concat(no_ability_routes);
    tearch_routes[1] = tearch_routes[1].concat(noAbilityOtherRoutes);
}
export default tearch_routes;